export default __webpack_public_path__ + "img/2b1235ec3a3b3e3be5468882824a76db.png";